//#region src/location_multi_vendor_support.ts
var LocationMultiVendorSupport = /* @__PURE__ */ function(LocationMultiVendorSupport) {
	LocationMultiVendorSupport[LocationMultiVendorSupport["Disabled"] = 0] = "Disabled";
	LocationMultiVendorSupport[LocationMultiVendorSupport["Enabled"] = 2] = "Enabled";
	return LocationMultiVendorSupport;
}(LocationMultiVendorSupport || {});
//#endregion
export { LocationMultiVendorSupport };

//# sourceMappingURL=location_multi_vendor_support.js.map